import { getLocale } from "../runtime";

const sv_articlenumber = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Artnr`
};

const articlenumber = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_articlenumber(inputs)
	return "articleNumber";
};

export { articlenumber as "articleNumber" };